// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__35pMp","modalFooterButton":"ModalNotes_modalFooterButton__QE4MY"};